import React, { useState } from "react";

const defaultState = {
  first_name: "",
  last_name: "",
  email: "",
};

export default function NewInspectionOwnerForm(props) {
  const { onSave, onClose } = props;
  const [state, setState] = useState({ ...defaultState });

  const onInputChange = (evt) => {
    state[evt.target.name] = evt.target.value;
    setState({ ...state });
  };

  const saveNewInspectionOwner = () => {
    const { first_name, last_name, email } = state;
    const newInspectionOwnerStr = `${first_name} ${last_name} (${email})`;
    onSave(newInspectionOwnerStr);
    setState({ ...defaultState });
  };

  return (
    <div className="new-inspection-owner-form create-new-container">
      <div className="create-instruction">Create a new inspection owner</div>
      <br/>
      <form autoComplete="off">
        <label>First name</label>
        <input
          type="text"
          autoComplete="off"
          name="first_name"
          defaultValue={state.first_name}
          onChange={onInputChange}
          placeholder="Enter the first name"
          required
        />
        <label>Last name</label>
        <input
          type="text"
          autoComplete="off"
          name="last_name"
          defaultValue={state.last_name}
          onChange={onInputChange}
          placeholder="Enter the last name"
          required
        />
        <label>Email</label>
        <input
          type="email"
          autoComplete="off"
          name="email"
          defaultValue={state.email}
          onChange={onInputChange}
          placeholder="Enter the email"
          required
        />
      </form>
      <div className="action" onClick={saveNewInspectionOwner}>
        Save
      </div>
      <div className="action" onClick={onClose}>
        Cancel
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/create_inspection_link/new_inspection_owner_form.js